import getConfig from 'next/config'

const appendCDN = (file: string) => {
  const { publicRuntimeConfig: { CDN } } = getConfig()
  
  let url = `${CDN}/${file}`.replace(/\/+/g, '/')
  if (CDN) {
    url = '/' + `${CDN}/${file}`
      .replace(/http(s?):/g, '')
      .replace(/\/+/g, '/')
  }

  return url
}

export default appendCDN
